import { Box, Button, Typography, Chip, CircularProgress } from "@mui/material";
import { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { GroupContext } from "../contexts/group";
import { People, CheckCircle, HourglassEmpty } from "@mui/icons-material";

const GroupReportCard = ({ group, completed, reviewerCount }) => {
  const { slugAssessment } = useParams();
  const { setCurrentGroup } = useContext(GroupContext);

  if (!group) return null;

  const handleOnClick = () => {
    setCurrentGroup(group);
    const storagedInfo = {
      group,
      level: 0,
    };
    localStorage.setItem("groupLL", JSON.stringify(storagedInfo));
  };

  return (
    <Box
      sx={{
        border: "1px solid #0F5385",
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-between",
        height: "100%",
        minHeight: "280px",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #0F5385 0%, #105B93 100%)",
          padding: "20px",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <People sx={{ fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {group?.name}
          </Typography>
        </Box>
        <Chip
          label={completed ? "Completed" : "Processing"}
          size="small"
          sx={{
            backgroundColor: completed ? "#69AF45" : "#FFC107",
            color: "white",
            fontWeight: 600,
          }}
        />
      </Box>

      {/* Content */}
      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flex: 1,
        }}
      >
        {/* Status Info */}
        <Box display="flex" alignItems="center" gap={1}>
          {completed ? (
            <CheckCircle sx={{ color: "#69AF45", fontSize: 24 }} />
          ) : (
            <HourglassEmpty sx={{ color: "#FFC107", fontSize: 24 }} />
          )}
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#666", fontWeight: 500, display: "block" }}
            >
              Status
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0F5385", fontWeight: 600 }}
            >
              {completed ? "Completed" : "Processing"}
            </Typography>
          </Box>
        </Box>

        {/* Reviewers Count */}
        <Box display="flex" alignItems="center" gap={1}>
          <People sx={{ color: "#0F5385", fontSize: 24 }} />
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#666", fontWeight: 500, display: "block" }}
            >
              Reviewers
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0F5385", fontWeight: 600 }}
            >
              {reviewerCount ?? 0}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Footer with Button */}
      <Box
        sx={{
          borderTop: "1px solid #e0e0e0",
          padding: "16px 20px",
          display: "flex",
          gap: "8px",
        }}
      >
        {completed ? (
          <Button
            onClick={handleOnClick}
            component={Link}
            to={`/${slugAssessment}/${group._id}/report`}
            variant="contained"
            fullWidth
            sx={{
              background: "linear-gradient(135deg, #0F5385 0%, #105B93 100%)",
              textTransform: "none",
              fontWeight: 600,
              color: "white",
            }}
          >
            VIEW RESULTS
          </Button>
        ) : (
          <Button
            disabled
            variant="contained"
            fullWidth
            sx={{ textTransform: "none" }}
          >
            PROCESSING...
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default GroupReportCard;
